import { render, staticRenderFns } from "./serviceOrderDetail.vue?vue&type=template&id=3460bd8e&"
import script from "./serviceOrderDetail.vue?vue&type=script&lang=ts&"
export * from "./serviceOrderDetail.vue?vue&type=script&lang=ts&"
import style0 from "./serviceOrderDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports